import React from "react";
import { RowWrapper, ColumnWrapper } from "../../DealershipTeam.styled";
import { Typography } from "@ann/web-components";

const DealershipTeamContent = ({ teamMembers = [] }) => {
  if (!teamMembers.length) {
    return null;
  }

  
  const pairs = [];
  for (let i = 0; i < teamMembers.length; i += 2) {
    pairs.push(teamMembers.slice(i, i + 2));
  }

  return (
    <>
      {pairs.map((pair, pairIndex) => (
        <RowWrapper key={pairIndex}>
          {pair.map((member, memberIndex) => (
            <ColumnWrapper key={`${pairIndex}-${memberIndex}`}>
              <Typography category='subtitle' weight='bold' size='small'>
                {member.member_description || 'Team Member'}
              </Typography>
              <Typography category='body' weight='regular' size='medium' color='body'>
                {member.member_full_name || '—'}
              </Typography>
            </ColumnWrapper>
          ))}
        </RowWrapper>
      ))}
    </>
  );
};

export default DealershipTeamContent;

